<div class="custom-selector" [ngClass]="{ 'sleep': isSleep }" >
  <select name="date-select" (change)="sendDate($event);flipArrowBack()" (select)="flipArrowBack()" (focus)="flipArrow()" (blur)="flipArrowBack()">
    <option *ngFor="let date of dates; let i = index" [value]="i">{{date.text}}</option>
  </select>
  <span class="custom-arrow" [ngStyle]="{'transform': transform }"></span>
</div>
